/**
 * Default labels used by the Cup Progress widgets across the app.
 * Coaches can override any of these in Settings → Cup Progress Labels.
 *
 * The `{round}` placeholder is replaced with the live round name
 * ("Quarter Final", "Final", etc.) at render time.
 */
export const CUP_PROGRESS_LABEL_DEFAULTS = {
  active_badge:      'In Progress',
  active_footer:     'Current: {round}',
  eliminated_badge:  'Eliminated',
  eliminated_footer: 'Knocked Out: {round}',
  winner_badge:      '🏆 Winners',
  winner_footer:     'Lifted the trophy in the {round}',
};

/**
 * Pull the resolved label for a given key from the user's customised
 * map, falling back to the default when the coach hasn't set one.
 */
export const cupLabel = (userLabels, key, round = '') => {
  const tmpl = (userLabels && userLabels[key]) || CUP_PROGRESS_LABEL_DEFAULTS[key];
  return (tmpl || '').replace('{round}', round || '');
};
